<template>
  <v-row no-gutters :class="['flex-nowrap', horizontalLayout ? 'flex-row' : 'flex-column']" :style="horizontalLayout ? 'gap: 16px' : ''">
    <v-col>
      <v-text-field v-model="search" :label="$t('common.label_search')" :disabled="disabled" prepend-icon="mdi-magnify" clearable />
    </v-col>
    <v-col>
      <v-row no-gutters align="center" justify="space-around">
        <v-col class="mr-4">
          <!-- sort selection -->
          <v-select clearable v-model="sort" :disabled="disabled" :items="availableSorts.map((sort) => sort.displayName)" :label="$t('common.label_sort')" prepend-icon="mdi-sort" />
        </v-col>
        <v-col cols="auto">
          <v-btn-toggle v-model="sortDirection" mandatory>
            <!-- ascending button -->
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <v-btn v-bind="attrs" v-on="on" color="primary" :disabled="sort === null || disabled" :value="false">
                  <v-icon class="white--text">mdi-arrow-up</v-icon>
                </v-btn>
              </template>
              <span> {{ $t("sort.ascending") }} </span>
            </v-tooltip>

            <!-- descending button -->
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <v-btn v-bind="attrs" v-on="on" color="primary text--white" :disabled="sort === null || disabled" :value="true">
                  <v-icon class="white--text">mdi-arrow-down</v-icon>
                </v-btn>
              </template>
              <span> {{ $t("sort.descending") }} </span>
            </v-tooltip>
          </v-btn-toggle>
        </v-col>
      </v-row>
    </v-col>
    <!-- filter selection -->
    <v-col>
      <v-select clearable v-model="filter" :disabled="disabled" :items="availableFilters.map((filter) => filter.displayName)" :label="$t('common.label_filter')" prepend-icon="mdi-filter" />
    </v-col>
  </v-row>
</template>

<script>
// mixins
import Constants from "@/mixins/constants.js";
import Responsive from "@/mixins/responsive.js";

export default {
  name: "OverviewSorter",

  emits: ["onSearch", "onSort", "onFilter"],

  mixins: [Constants, Responsive],

  props: {
    bookingType: String,
    availableFilters: Array,
    availableSorts: Array,
    disabled: Boolean,
    horizontal: Boolean,
  },

  data() {
    return {
      sortDesc: false,
      searchValue: "",
      activeSort: null,
      activeFilter: null,
    };
  },

  methods: {
    // #region events
    /**
     * fires the "onSort" event
     *
     * payload is an array with an object the v-data-iterator can work with
     */
    fireOnSort() {
      if (this.activeSort) this.$emit("onSort", {key: this.activeSort.key, sortDesc: this.sortDesc});
    },
    // #endregion
  },

  computed: {
    horizontalLayout(){
      return this.currentBreakpoint <= 3;
    },

    /** eventhandler for the search input */
    search: {
      get() {
        return this.searchValue;
      },
      set(newSearchValue) {
        this.searchValue = newSearchValue;
        this.$emit("onSearch", newSearchValue);
      },
    },

    /** eventhandler for the sort direction */
    sortDirection: {
      get() {
        return this.sortDesc;
      },
      set(newSortDirection) {
        this.sortDesc = newSortDirection;
        if (this.activeSort !== null) this.fireOnSort();
      },
    },

    /** eventhandler for the sort combobox */
    sort: {
      get() {
        return this.activeSort ? this.activeSort.displayName : null;
      },
      set(whatToSort) {
        // selection was cleared
        if (whatToSort === null) {
          this.activeSort = null;
          this.$emit("onSort", null);
          return;
        }

        var sortFromDisplayName = this.availableSorts.filter((sort) => sort.displayName === whatToSort)[0];
        this.activeSort = sortFromDisplayName;
        this.fireOnSort();
      },
    },

    /** eventhandler for the filter combobox */
    filter: {
      get() {
        return this.activeFilter ? this.activeFilter.displayName : "";
      },
      set(whatToFilter) {
        // selection was cleared
        if (whatToFilter === null) {
          this.activeFilter = null;
          this.$emit("onFilter", null);
          return;
        }

        var filterFromDisplayName = this.availableFilters.filter((filter) => filter.displayName === whatToFilter)[0];
        this.activeFilter = filterFromDisplayName;
        this.$emit("onFilter", this.activeFilter.key);
      },
    },
  },
};
</script>
